/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function DotsSix(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle cx={60} cy={92} r={12} />
      <Circle cx={128} cy={92} r={12} />
      <Circle cx={196} cy={92} r={12} />
      <Circle cx={60} cy={164} r={12} />
      <Circle cx={128} cy={164.0001} r={12} />
      <Circle cx={196} cy={164} r={12} />
    </Svg>
  );
}

export default DotsSix;
